import React, { Dispatch, SetStateAction } from 'react';
import {
  MediaItem,
  MediaItemSelectedType,
  MediaLibraryFilterAction,
  MediaLibraryFilterType
} from '../../../models/media';
import { MediaLibraryFilterMenu } from './MediaLibraryFilterMenu';
import { Modal } from '../../../components/containers/Modal';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { MediaGridContext } from './MediaGrid/MediaGrid.view';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { BreakpointsEnum } from '../../../constants/breakpoints';
import { DeleteConfirmationModal } from './DeleteConfirmationModal';
import { FileWithPreview } from './AddMediaSelectorModal/AddMediaSelectorModal.view';
import { FilterMenuContextType } from './MediaLibraryFilterMenu/MediaLibraryFilterMenu.view';
import { MediaLibraryModalLayoutView } from './MediaLibraryModalLayout.view';
import { MediaLibraryPageLayoutView } from './MediaLibraryPageLayout.view';
import { PostEditorPublicAction } from '../../PostEditor/states/PostEditorActions';
import { ExternalMedia, MediaUploadType } from '../../../hooks/useMediaUpload';

export type MediaLibraryViewProps = {
  loadingMore: boolean;
  loading: boolean;
  mediaItems: MediaItem[];
  filters: MediaLibraryFilterType;
  dispatchFilters: Dispatch<MediaLibraryFilterAction>;
  showFilterModal: boolean;
  setShowFilterModal: Dispatch<SetStateAction<boolean>>;
  showSelectionModal: boolean;
  showAddFromLibraryModal: boolean;
  setShowAddFromLibraryModal: Dispatch<SetStateAction<boolean>>;
  setShowSelectionModal: Dispatch<SetStateAction<boolean>>;
  showAddMediaByUrlModal: boolean;
  setShowAddMediaByUrlModal: Dispatch<SetStateAction<boolean>>;
  showFindImagesModal: boolean;
  setShowFindImagesModal: Dispatch<SetStateAction<boolean>>;
  showDeleteConfirmationModal: boolean;
  setShowDeleteConfirmationModal: Dispatch<SetStateAction<boolean>>;
  selectedMediaItems: MediaItemSelectedType[];
  setSelectedMediaItems: React.Dispatch<React.SetStateAction<MediaItemSelectedType[]>>;
  fileUploadHandler: (files: FileWithPreview[] | ExternalMedia[]) => void;
  deleteMediaHandler: (selectedMedia: MediaItemSelectedType[], isBulkDelete?: boolean) => void;
  fetchMoreMediaItemsHandler: () => void;
  hasReachedFetchLimit: boolean;
  singleActionableItemId: MediaItemSelectedType[] | undefined;
  onCloseHandler?: VoidFunction;
  isInPostEditor: boolean;
  dispatchPostEditor: Dispatch<PostEditorPublicAction>;
  queueUploads: MediaUploadType['queueUploads'];
  setDesignInCanvaModal: Dispatch<SetStateAction<boolean>>;
  showDesignInCanvaModal: boolean;
  imagesIdsWithErrorSelected: MediaItemSelectedType[];
  setImagesIdsWithErrorSelected: React.Dispatch<React.SetStateAction<MediaItemSelectedType[]>>;
};

export const MediaLibraryViewLayout = (props: MediaLibraryViewProps): JSX.Element => {
  const breakpoint = useBreakpoints();
  // TODO Refs should not be passed as props. This is antipattern

  const showFilterModal = props.isInPostEditor
    ? props.showFilterModal &&
      (breakpoint === BreakpointsEnum.small ||
        breakpoint === BreakpointsEnum.medium ||
        breakpoint === BreakpointsEnum.tabletportrait)
    : props.showFilterModal && breakpoint === BreakpointsEnum.small;

  const selectedMediaItemIds = props.singleActionableItemId ?? props.selectedMediaItems;

  return (
    <>
      {props.isInPostEditor ? (
        <MediaLibraryModalLayoutView {...props} gridContext={MediaGridContext.POST_EDITOR_MEDIA_LIBRARY} />
      ) : (
        <MediaLibraryPageLayoutView {...props} gridContext={MediaGridContext.PAGE} />
      )}
      {showFilterModal && (
        <Modal
          onClose={() => props.setShowFilterModal(false)}
          showCloseIcon={true}
          primaryButtonAction={() => props.setShowFilterModal(false)}
          primaryButtonColor={ButtonColorsEnum.primary}
          primaryButtonTitle={'Apply Filters'}
          isFilter
          title={'Filters'}>
          <MediaLibraryFilterMenu
            filters={props.filters}
            dispatchFilters={props.dispatchFilters}
            context={FilterMenuContextType.MODAL}
          />
        </Modal>
      )}
      {props.showDeleteConfirmationModal && (
        <DeleteConfirmationModal
          onCloseHandler={() => props.setShowDeleteConfirmationModal(false)}
          onConfirmationHandler={() => props.deleteMediaHandler(selectedMediaItemIds, true)}
        />
      )}
    </>
  );
};
